module.exports = __webpack_public_path__ + "img/open-play-duration-icon.7131e887.png";